import { useLayoutEffect, useRef, useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'

import { useIsPrinting } from './useIsPrinting'

const useResizeObserver = <T extends Element = HTMLDivElement>() => {
  const ref = useRef<T>(null)
  const isPrinting = useIsPrinting()

  const [dimensions, changeDimensions] = useState({
    height: 0,
    width: 0,
  })

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries) || !entries.length) {
        return
      }

      const { contentRect } = entries[0]

      if (!isPrinting) {
        changeDimensions({
          height: contentRect.height,
          width: contentRect.width,
        })
      }
    })

    resizeObserver.observe(element)

    return () => resizeObserver.unobserve(element)
  }, [isPrinting])

  return {
    dimensions,
    ref,
  }
}

export default useResizeObserver
